"use client";
import React from "react";
import {AnimatePresence, motion} from "framer-motion";

interface InfoCardProps {
    title: string;
    icon: React.ReactNode;
    content: (string | React.ReactNode)[];
    isOpen: boolean;
    onClick: () => void;
    delay?: number;
}

const InfoCard: React.FC<InfoCardProps> = ({title, icon, content, isOpen, onClick, delay = 0}) => {
    return (
        <motion.div
            className={`p-6 md:p-10 rounded-3xl shadow-xl border border-white/40 text-center cursor-pointer hover:shadow-2xl transition-all overflow-hidden bg-white text-main`}
            initial={{opacity: 0, y: 40}}
            whileInView={{opacity: 1, y: 0}}
            transition={{duration: 0.5, delay}}
            viewport={{once: true}}
            onClick={onClick}
        >
            <motion.div
                className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-btn text-white text-2xl shadow-lg"
                animate={{rotate: isOpen ? 360 : 0}}
                transition={{duration: 0.6}}
            >
                {icon}
            </motion.div>

            <h3 className="text-2xl font-bold mb-4 text-main">{title}</h3>

            <AnimatePresence>
                {isOpen && content && content.length > 0 && (
                    <motion.ul
                        key={isOpen ? 'open' : 'closed'}
                        className="space-y-2 mt-4 text-base md:text-lg text-main bg-btn/10 border border-btn/25 rounded-2xl p-4 md:p-6 shadow-inner"
                        initial={{opacity: 0, y: -20, scale: 0.95}}
                        animate={{opacity: 1, y: 0, scale: 1}}
                        exit={{opacity: 0, y: -10, scale: 0.95}}
                        transition={{duration: 0.5}}
                    >
                        {content.map((line, idx) => (
                            <li key={idx}>- {line}</li>
                        ))}
                    </motion.ul>
                )}
            </AnimatePresence>
        </motion.div>
    );
};

export default InfoCard;
